import { createContext } from 'react';
import { createNamespace as _createNamespace } from '../utils';
export var defaultPrefixCls = 'rv';
export var defaultIconPrefixCls = 'van-icon';
export var INITIAL_STATE = {
  iconPrefix: defaultIconPrefixCls,
  prefixCls: defaultPrefixCls,
  createNamespace: function createNamespace(name, prefix) {
    return _createNamespace(name, prefix);
  }
};
var ConfigProvider = /*#__PURE__*/createContext(INITIAL_STATE);
export default ConfigProvider;